export const CLOSE_MENU = 'CLOSE_MENU'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const TOGGLE_WITHOUT_ANIMATION = 'TOGGLE_WITHOUT_ANIMATION'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js